import React, { ComponentProps, useCallback, useState } from 'react';
import { tc } from '../../lib/trackingContext';
import { createApplePaySession } from '../../lib/apple/createApplePaySession';
import { useApplePayButton, ApplePayButton } from '../ApplePay';

type Props = Omit<ComponentProps<typeof ApplePayButton>, 'onClick'>;

export const CheckoutApplePayButton: React.FC<Props> = props => {
  const { getApplePayCheckoutSession } = useApplePayButton();
  const [session, setSession] = useState<ApplePaySession | null>(null);

  const trackThirdParty = useCallback(() => {
    tc.track('Third Party Payment Method Flow Selected', {
      addToTrackingEvent: {
        payment_type: 'APPLE',
        label: 'APPLE'
      }
    });
  }, []);

  const handleClick = useCallback(() => {
    if (session) return;

    const { version, request } = getApplePayCheckoutSession();

    if (request) {
      const newSession = createApplePaySession(version, request, () => setSession(null));
      setSession(newSession);
    }

    trackThirdParty();
  }, [getApplePayCheckoutSession, session, trackThirdParty]);

  return (
    <ApplePayButton
      {...props}
      session={session}
      onClick={handleClick}
      onError={() => setSession(null)}
    />
  );
};
